import { render, staticRenderFns } from "./UiIconTooltip.vue?vue&type=template&id=29ed2a44"
import script from "./UiIconTooltip.vue?vue&type=script&lang=js"
export * from "./UiIconTooltip.vue?vue&type=script&lang=js"
import style0 from "./UiIconTooltip.vue?vue&type=style&index=0&id=29ed2a44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports